import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgPasswordReset',
})
export default class CmgPasswordReset extends Vue {
  email = '';
  isPasswordResetRequest = true;

  onSuccessfulResetRequest(email: string): void {
    this.email = email;
    this.isPasswordResetRequest = false;
  }

  onRetryPasswordReset(): void {
    this.isPasswordResetRequest = true;
  }
}